import { render, staticRenderFns } from "./headerBox.vue?vue&type=template&id=18d3f566&scoped=true"
import script from "./headerBox.vue?vue&type=script&lang=js"
export * from "./headerBox.vue?vue&type=script&lang=js"
import style0 from "./headerBox.vue?vue&type=style&index=0&id=18d3f566&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d3f566",
  null
  
)

export default component.exports